import { render, staticRenderFns } from "./ActivityRule.vue?vue&type=template&id=273ae468&"
import script from "./ActivityRule.vue?vue&type=script&lang=js&"
export * from "./ActivityRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports